import { apiRequest } from "./client";
import type { PublicSiteSettings } from "@/admin/types";

export const fetchSiteSettings = () => {
  return apiRequest<PublicSiteSettings>("/site/settings");
};
